<template>
  <div class="">
    <DashboardNavbar
      v-on:updateViewType="updateViewType('educationalGroupStudents', $event)"
      :viewType="generalSetting.educationalGroupStudents.viewType"
      :viewTypeStatus="true"
      :btnAddTitle="$t('EducationalGroupStudents.add')"
      :btnAddName="'EducationalGroupStudentAdd'"
      :btnAddStatus="checkPrivilege(hasEducationalGroupStudentAdd())"
      :btnAddTitleOther="$t('MonitorScoreExams.add')"
      :btnAddNameOther="'MonitorScoreExamAdd'"
      :btnAddStatusOther="checkPrivilege(hasMonitorScoreExamAdd()) && hasData"
      v-on:addMany="setMonitorScoreStudentsDataHandler($event)"
      :filterSheetName="'filterSheet'"
      :filterSheetStatus="true"
    />
    <PreLoader v-if="isLoading" />

    <div class="app-content pagination-with-content">
      <template v-if="hasData">
        <EducationalGroupStudentTable
          v-if="
            generalSetting.educationalGroupStudents.viewType == VIEW_TYPES.table
          "
          v-on:setEducationalGroupStudentData="
            educationalGroupStudents.educationalGroupStudent.fillData($event)
          "
          v-on:setEducationalGroupUpdateWarningData="
            educationalGroupUpdateWarning.fillData($event)
          "
          v-on:setMonitorScoreExamData="monitorScoreExam.fillData($event)"
          v-on:certificateExport="
            certificateExport($event.educationalGroupStudentToken)
          "
          v-on:certificateDeliver="
            certificateDeliver($event.educationalGroupStudentToken)
          "
          v-on:makeFreezed="makeFreezed($event.educationalGroupStudentToken)"
          v-on:makeNotFreezed="
            makeNotFreezed($event.educationalGroupStudentToken)
          "
          :educationalGroupStudentsData="
            educationalGroupStudents.educationalGroupStudentsData
          "
          :defaultImg="
            educationalGroupStudents.educationalGroupStudent.defaultImg
          "
          :filterData="educationalGroupStudents.filterData"
        />

        <EducationalGroupStudentCards
          v-else-if="
            generalSetting.educationalGroupStudents.viewType == VIEW_TYPES.cards
          "
          :educationalGroupStudentsData="
            educationalGroupStudents.educationalGroupStudentsData
          "
          v-on:setEducationalGroupStudentData="
            educationalGroupStudents.educationalGroupStudent.fillData($event)
          "
          v-on:setEducationalGroupUpdateWarningData="
            educationalGroupUpdateWarning.fillData($event)
          "
          v-on:setMonitorScoreExamData="monitorScoreExam.fillData($event)"
          v-on:certificateExport="
            certificateExport($event.educationalGroupStudentToken)
          "
          v-on:certificateDeliver="
            certificateDeliver($event.educationalGroupStudentToken)
          "
          v-on:makeFreezed="makeFreezed($event.educationalGroupStudentToken)"
          v-on:makeNotFreezed="
            makeNotFreezed($event.educationalGroupStudentToken)
          "
          :defaultImg="
            educationalGroupStudents.educationalGroupStudent.defaultImg
          "
          :filterData="educationalGroupStudents.filterData"
        />

        <MonitorScoreExamAdd
          :MonitorScoreExam="monitorScoreExam"
          :monitorScoreStudentsDataHandler="monitorScoreStudentsDataHandler"
        />

        <EducationalGroupUpdateWarning
          :educationalGroupUpdateWarning="educationalGroupUpdateWarning"
          v-on:refresh="getAllEducationalGroupStudents()"
        />

        <EducationalGroupStudentFreeze
          :educationalGroupStudentToken="
            educationalGroupStudents.educationalGroupStudent
              .educationalGroupStudentToken
          "
          v-on:refresh="getAllEducationalGroupStudents()"
        />
        <ActionsData
          :actionsData="educationalGroupStudents.educationalGroupStudent"
        />
        <EducationalGroupStudentInfo
          :educationalGroupStudent="
            educationalGroupStudents.educationalGroupStudent
          "
          class=""
        />
        <MediaPackageCodesFilter
          v-on:isLoading="isLoading = $event"
          :joinInEducationalGroupToken="
            educationalGroupStudents.educationalGroupStudent
              .educationalGroupInfoData.educationalGroupToken
          "
          :userToken="
            educationalGroupStudents.educationalGroupStudent.studentUserInfoDate
              .userToken
          "
        />
        <StudentStatisticsReport
          :educationalGroupToken="
            educationalGroupStudents.educationalGroupStudent
              .educationalGroupInfoData.educationalGroupToken
          "
          v-on:isLoading="isLoading = $event"
          :educationalGroupStudentToken="
            educationalGroupStudents.educationalGroupStudent
              .educationalGroupStudentToken
          "
        />
      </template>
      <ExceptionWithImg
        v-if="exceptionMsg"
        :msg="exceptionMsg"
        :image="exceptionImg"
      />
      <CustomPagination
        v-if="hasData"
        :paginationData="educationalGroupStudents.filterData"
        v-on:changePagination="changePagination($event)"
      />
      <EducationalGroupStudentFilter
        :theFilterData="educationalGroupStudents.filterData"
        v-on:search="search($event)"
      />

      <EducationalGroupStudentAdd
        :educationalGroupStudent="
          educationalGroupStudents.educationalGroupStudent
        "
        :tokensData="{
          educationalGroupToken: educationalGroupToken,
          educationalCategoryToken: educationalCategoryToken,
        }"
        v-on:refresh="getAllEducationalGroupStudents()"
      />
    </div>
  </div>
</template>

<script>
import { STATUS, VIEW_TYPES } from "./../../../utils/constants";
import DashboardNavbar from "./../../../layouts/components/DashboardNavbar.vue";
import PreLoader from "./../../../components/general/PreLoader.vue";
import MonitorScoreExamAdd from "./../../../views/educational/monitorScoreExams/components/MonitorScoreExamAdd.vue";
import ExceptionWithImg from "./../../../components/general/ExceptionWithImg.vue";
import ActionsData from "./../../../components/general/ActionsData.vue";
import CustomPagination from "./../../../components/general/CustomPagination.vue";
import EducationalGroupStudentAdd from "./components/EducationalGroupStudentAdd.vue";
import EducationalGroupStudentCards from "./components/EducationalGroupStudentCards.vue";
import EducationalGroupStudentFreeze from "./components/EducationalGroupStudentFreeze.vue";
import EducationalGroupStudentTable from "./components/EducationalGroupStudentTable.vue";
import EducationalGroupUpdateWarning from "./components/EducationalGroupUpdateWarning.vue";
import EducationalGroupStudentInfo from "./components/EducationalGroupStudentInfo.vue";
import MediaPackageCodesFilter from "./../../reports/components/MediaPackageCodesFilter.vue";
import StudentStatisticsReport from "./../../reports/components/StudentStatisticsReport.vue";
import EducationalGroupStudentFilter from "./components/EducationalGroupStudentFilter.vue";
import EducationalGroupStudents from "./../../../models/educational/educationalGroupStudents/EducationalGroupStudents";
import EducationalGroupUpdateWarningClass from "./../../../models/educational/educationalGroupStudents/EducationalGroupUpdateWarning";
import MonitorScoreExam from "./../../../models/educational/monitorScoreExams/MonitorScoreExam";
import apiEducationalGroupStudent from "./../../../api/educational/educationalGroupStudents";
import { getDialogOfActivationTypes } from "./../../../utils/dialogsOfConstantsLists";
import generalMixin from "./../../../utils/generalMixin";
import generalSettingsMixin from "./../../../utils/generalSettingsMixin";
import { checkPrivilege, objectToFormData } from "./../../../utils/functions";
import {
  hasEducationalGroupStudentAdd,
  hasMonitorScoreExamAdd,
} from "./../../../utils/privilegeHelper";
import {
  CERTIFICATE_STATUS_TYPE,
  FREEZE_STATUS_TYPE,
} from "./../../../utils/constantLists";

export default {
  mixins: [generalMixin, generalSettingsMixin],
  components: {
    DashboardNavbar,
    PreLoader,
    MonitorScoreExamAdd,
    ExceptionWithImg,
    ActionsData,
    CustomPagination,
    EducationalGroupStudentAdd,
    EducationalGroupStudentCards,
    EducationalGroupStudentFreeze,
    EducationalGroupStudentTable,
    EducationalGroupUpdateWarning,
    EducationalGroupStudentInfo,
    MediaPackageCodesFilter,
    StudentStatisticsReport,
    EducationalGroupStudentFilter,
  },
  computed: {
    hasData() {
      return (
        this.educationalGroupStudents.educationalGroupStudentsData.length != 0
      );
    },
  },
  props: {
    educationalGroupToken: {
      type: String,
      default: "",
    },
    educationalCategoryToken: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      educationalGroupStudents: new EducationalGroupStudents(),
      educationalGroupUpdateWarning: new EducationalGroupUpdateWarningClass(),
      monitorScoreExam: new MonitorScoreExam(),
      VIEW_TYPES,
      activationTypesTokenOptions: getDialogOfActivationTypes(),
      monitorScoreStudentsDataHandler: [],
    };
  },
  methods: {
    checkPrivilege,
    objectToFormData,
    hasEducationalGroupStudentAdd,
    hasMonitorScoreExamAdd,
    setMonitorScoreStudentsDataHandler(addMany) {
      this.monitorScoreExam.addMany = addMany;
      let list = this.educationalGroupStudents.educationalGroupStudentsData.map(
        (i) => {
          let item = {
            educationalGroupStudentToken: i.educationalGroupStudentToken,
            studentScore: 0,
            student: {
              fullCode: i.studentUserInfoDate.fullCode,
              userNameCurrent: i.studentUserInfoDate.userNameCurrent,
            },
          };
          return item;
        }
      );

      this.monitorScoreStudentsDataHandler = list;
    },
    changePagination(pagination) {
      this.educationalGroupStudents.filterData.fillData(pagination);
      this.getAllEducationalGroupStudents();
    },

    search(data) {
      this.educationalGroupStudents.filterData.fillData(data);
      this.getAllEducationalGroupStudents();
    },
    async certificateDeliver(educationalGroupStudentToken) {
      this.isLoading = true;
      let params = {
        educationalGroupStudentToken: educationalGroupStudentToken,
        certificateStatusToken: CERTIFICATE_STATUS_TYPE.Deliver,
      };
      let formData = objectToFormData(params);

      try {
        const response =
          await apiEducationalGroupStudent.changeCertificateStatus(formData);
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser", response.data.msg);
          this.showMsg(response.data.msg);
        } else {
          this.showMsg(response.data.msg, false);
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
      this.getAllEducationalGroupStudents();
    },

    async certificateExport(educationalGroupStudentToken) {
      this.isLoading = true;
      let params = {
        educationalGroupStudentToken: educationalGroupStudentToken,
        certificateStatusToken: CERTIFICATE_STATUS_TYPE.Export,
      };
      let formData = objectToFormData(params);
      try {
        const response =
          await apiEducationalGroupStudent.changeCertificateStatus(formData);
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser", response.data.msg);
          this.showMsg(response.data.msg);
        } else {
          this.showMsg(response.data.msg, false);
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
      this.getAllEducationalGroupStudents();
    },

    async makeNotFreezed(educationalGroupStudentToken) {
      this.isLoading = true;
      let params = {
        educationalGroupStudentToken: educationalGroupStudentToken,
        freezeStatusToken: FREEZE_STATUS_TYPE.NotFreezed,
      };
      let formData = objectToFormData(params);
      try {
        const response = await apiEducationalGroupStudent.changeFreezeStatus(
          formData
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser", response.data.msg);
          this.showMsg(response.data.msg);
        } else {
          this.showMsg(response.data.msg, false);
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
      this.getAllEducationalGroupStudents();
    },

    async getAllEducationalGroupStudents() {
      this.isLoading = true;
      try {
        this.educationalGroupStudents.educationalGroupStudentsData = [];
        const response = await apiEducationalGroupStudent.getAll(
          this.educationalGroupStudents.filterData
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.exceptionMsg = null;
        } else if (response.data.status == STATUS.NO_INTERNET) {
          this.exceptionMsg = response.data.msg;
          this.exceptionImg = "illustrator-noInternet.svg";
        } else if (response.data.status == STATUS.NO_CONTENT) {
          this.exceptionMsg = response.data.msg;
          this.exceptionImg = "illustrator-noData.svg";
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser", response.data.msg);
        } else {
          this.exceptionMsg = response.data.msg;
          this.exceptionImg = null;
        }
        this.educationalGroupStudents.fillData(response.data);
      } catch (error) {
        this.exceptionMsg = this.$t("errorCatch");
        this.exceptionImg = null;
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.educationalGroupStudents.filterData.educationalGroupToken =
      this.educationalGroupToken || this.$route.params.educationalGroupToken;
    this.educationalGroupStudents.filterData.educationalCategoryToken =
      this.educationalCategoryToken ||
      this.$route.params.educationalCategoryToken;
    this.getAllEducationalGroupStudents();
  },
};
</script>
